import { Component, OnInit, Directive, Input, HostBinding, HostListener, ChangeDetectorRef } from '@angular/core';
import { flipBlockAnimation } from '@app/system/animations/flip-block.animate';

@Component({
	selector: 'flip-block-item',
	templateUrl: './flip-block-item.component.html',
	styleUrls: ['./flip-block-item.component.scss'],
	animations: [flipBlockAnimation]
})
export class FlipBlockItemComponent implements OnInit {

	@Input() data: any = {};
	@HostBinding('@flipBlockAnimation')

	trigger = 'closed';

	@HostListener('@flipBlockAnimation.done', ['$event'])
	doneDrawerHandler(event: any): void {
	}

	constructor(
		private cdref: ChangeDetectorRef
	) {
	}

	ngOnInit(): void {
	}
}

@Directive({
	selector: 'icon'
})
export class FlipItemIcon { }

@Directive({
	selector: 'block-title'
})
export class FlipItemTitle { }

@Directive({
	selector: 'content-area'
})
export class FlipItemContentArea {
	@HostBinding('style.width') private width = '100%';
}

@Directive({
	selector: 'date-caption'
})
export class FlipItemDateCaption { }

@Directive({
	selector: 'date'
})
export class FlipItemDate { }

@Directive({
	selector: 'status'
})
export class FlipItemStatus { }
